import { render, staticRenderFns } from "./EditGroupContactsPage.vue?vue&type=template&id=638e0f94&scoped=true&"
import script from "./EditGroupContactsPage.vue?vue&type=script&lang=js&"
export * from "./EditGroupContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e0f94",
  null
  
)

export default component.exports